import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=00f54cd4&"
import script from "./Materials.vue?vue&type=script&lang=js&"
export * from "./Materials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports